module.exports = __webpack_public_path__ + "static/img/bc1-3.f240fd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-3.png
// module id = 820
// module chunks = 0